import React from "react";
import { FaPhone, FaEnvelope, FaHome } from "react-icons/fa";
import { Helmet } from "react-helmet";

function Contact() {
  const [formData, setFormData] = React.useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const [showModal, setShowModal] = React.useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowModal(true);
    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      message: "",
    });
    setTimeout(() => {
      setShowModal(false);
    }, 4000);
  };

  return (
    <>
      <Helmet>
        <title>Fapugo Barbershop - Επαγγελματικό Κουρείο και Περιποίηση</title>
        <meta
          name="description"
          content="Fapugo Barbershop - Επαγγελματικές υπηρεσίες κουρέματος και περιποίησης. Ανακαλύψτε τις τελευταίες τάσεις στο ανδρικό στυλ και grooming."
        />
      </Helmet>

      <div className="contact-container">
        <div className="contact-header">
          <h1 className="contact-title">Επικοινωνήστε μαζί μας</h1>
          <p className="contact-subtitle">
            Είμαστε εδώ για να απαντήσουμε σε κάθε σας ερώτηση και να σας
            βοηθήσουμε
          </p>
        </div>

        <div className="contact-content">
          <div className="contact-info-section">
            <h2 className="contact-info-title">Πληροφορίες Επικοινωνίας</h2>

            <div className="contact-info-item">
              <FaHome className="contact-icon" />
              <div className="contact-info-text">
                <h4>Διεύθυνση</h4>
                <p>
                  Kolokotronis 23
                  <br />
                  Gazi 715 00, Greece
                </p>
              </div>
            </div>

            <div className="contact-info-item">
              <FaPhone className="contact-icon" />
              <div className="contact-info-text">
                <h4>Τηλέφωνο</h4>
                <p>+302816007086</p>
              </div>
            </div>

            <div className="contact-info-item">
              <FaEnvelope className="contact-icon" />
              <div className="contact-info-text">
                <h4>Email</h4>
                <p>
                  Email:{" "}
                  <a href="mailto:fapugo@hotmail.com">fapugo@hotmail.com</a>
                </p>
                <p>
                  <a href="https://wa.me/302816007086">WhatsApp</a>
                </p>
                <p>
                  <a href="https://viber.me/302816007086">Viber</a>
                </p>
              </div>
            </div>
          </div>

          <div className="contact-form-section">
            <h2 className="contact-form-title">Στείλτε μας Μήνυμα</h2>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="firstName">Όνομα</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="lastName">Επώνυμο</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Τηλέφωνο</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  pattern="^\+?[0-9\s\-]{7,20}$"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Μήνυμα</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>

              <button type="submit" className="submit-btn-3d">
                Αποστολή Μηνύματος
              </button>
            </form>
          </div>
        </div>

        <div className="business-info-section">
          <div className="business-letter">
            <p>Αγαπητέ επισκέπτη,</p>
            <p>
              Σας ευχαριστούμε που επιλέξατε να επικοινωνήσετε με το Fapugo
              Barbershop. Η εταιρεία μας δραστηριοποιείται στον τομέα της
              ανδρικής περιποίησης με πάθος και αφοσίωση εδώ και πολλά χρόνια.
              Είμαστε υπερήφανοι για την ποιότητα των υπηρεσιών μας και τη σχέση
              εμπιστοσύνης που έχουμε χτίσει με τους πελάτες μας.
            </p>
            <p>
              Το blog μας δημιουργήθηκε για να μοιραστούμε την εμπειρία και τις
              γνώσεις μας με όσους ενδιαφέρονται για το ανδρικό grooming και
              στυλ. Είτε αναζητάτε συμβουλές για την περιποίηση της γενειάδας
              σας, είτε θέλετε να μάθετε για τις τελευταίες τάσεις στο
              hairstyling, είμαστε εδώ για να σας βοηθήσουμε.
            </p>
            <p>
              <strong>Η ομάδα μας είναι πάντα στη διάθεσή σας</strong> για να
              απαντήσει σε ερωτήσεις, να παρέχει συμβουλές ή να σας εξυπηρετήσει
              με οποιονδήποτε τρόπο χρειάζεστε. Μη διστάσετε να επικοινωνήσετε
              μαζί μας μέσω οποιουδήποτε από τα διαθέσιμα κανάλια επικοινωνίας.
            </p>

            <div className="business-details">
              <p>
                <strong>Επωνυμία:</strong> Fapugo Barbershop
              </p>
              <p>
                <strong>Διεύθυνση:</strong> Kolokotronis 23, Gazi 715 00, Greece
              </p>
              <p>
                <strong>Τηλέφωνο:</strong> +302816007086
              </p>
              <p>
                <strong>ΑΦΜ:</strong> 51604280
              </p>
            </div>
          </div>
        </div>

        {showModal && (
          <div className="modal-overlay" onClick={() => setShowModal(false)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <h2>Ευχαριστούμε!</h2>
              <p>
                Το μήνυμά σας έχει σταλεί επιτυχώς. Θα επικοινωνήσουμε μαζί σας
                το συντομότερο δυνατό.
              </p>
              <button
                onClick={() => setShowModal(false)}
                className="btn btn-primary"
              >
                Κλείσιμο
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Contact;
